import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  IStoreCouponsStateError,
  IStoreCouponsStateSuccess,
} from '@boxx/store-core';
import { Store } from '@ngrx/store';
import * as fromReducer from '../store.reducer';
import * as fromCouponsActions from './store-coupons.actions';
import * as fromSelectors from './store-coupons.selectors';

@Injectable()
export class StoreCouponsStore
  implements
    IStoreBase<
      any[],
      IStoreCouponsStateSuccess,
      IStoreCouponsStateError
    >
{
  constructor(public store: Store<fromReducer.IStoreState>) {}

  get loading$() {
    return this.store.select(fromSelectors.getStoreCouponsIsLoading);
  }
  get data$() {
    return this.store.select(fromSelectors.getStoreCouponsData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getStoreCouponsHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getStoreCouponsError);
  }
  get success$() {
    return this.store.select(fromSelectors.getStoreCouponsSuccess);
  }

  fetch = () =>
    this.store.dispatch(fromCouponsActions.loadCouponsBeginAction());

  create = (payload: any) =>
    this.store.dispatch(
      fromCouponsActions.createCouponBeginAction({ payload })
    );

  update = (payload: any) =>
    this.store.dispatch(
      fromCouponsActions.updateCouponBeginAction({ payload })
    );

    updateStatus = (payload: any) =>
      this.store.dispatch(
        fromCouponsActions.updateCouponSuccessAction({ payload })
      );

  delete = (id: number) =>
    this.store.dispatch(fromCouponsActions.deleteCouponBeginAction({ id }));

    getSingleCoupon = (id: number) =>
    this.store.dispatch(
      fromCouponsActions.loadSingleCouponBeginAction( {id} )
    );

    getUpdatedCoupon = (id: number) =>
    this.store.dispatch(
      fromCouponsActions.loadUpdatedCouponBeginAction( {id} )
    );
}
